import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  CardContent,
  TextField,
  IconButton,
  Chip,
  Breadcrumbs,
  Button,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";

const FunctionRoles = () => {
  const { functionId } = useParams();
  const [functionName, setFunctionName] = useState("");
  const [roles, setRoles] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedRoleIds, setSelectedRoleIds] = useState([]);
  const navigate = useNavigate();

  const token = Cookies.get("token");

  useEffect(() => {
    const fetchFunctionName = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/profile/job-functions`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.ok) {
        const data = await res.json();
        const func = data.find((f) => String(f.id) === String(functionId));
        if (func) setFunctionName(func.name);
      }
    };
    fetchFunctionName();
  }, [functionId]);

  useEffect(() => {
    const fetchRoles = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/profile/job-roles/${functionId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (res.ok) {
        const data = await res.json();
        setRoles(data);
      }
    };
    fetchRoles();
  }, [functionId]);

  const filteredRoles = roles.filter((r) =>
    r.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleCardClick = (roleId) => {
    setSelectedRoleIds((prev) =>
      prev.includes(roleId)
        ? prev.filter((id) => id !== roleId)
        : [...prev, roleId]
    );
  };

  const handleDiscoverCandidates = () => {
    if (selectedRoleIds.length > 0) {
      navigate(
        `/corporate/discover-candidates/${functionId}/roles/${selectedRoleIds.join(
          ","
        )}/candidates`
      );
    }
  };

  return (
    <Box sx={{ p: 4 }}>
      <Breadcrumbs sx={{ mb: 2 }} aria-label="breadcrumb">
        <Typography
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          color="inherit"
          onClick={() => navigate("/corporate/discover-candidates")}
        >
          <ArrowBackIcon sx={{ mr: 0.5 }} fontSize="inherit" />
          {functionName || "Back"}
        </Typography>
      </Breadcrumbs>
      <Typography variant="h4" sx={{ mb: 1 }}>
        {functionName}
      </Typography>
      <Typography variant="subtitle1" sx={{ mb: 3 }}>
        Select areas of {functionName || "this function"} that you need
        candidates for.
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <Typography variant="h6" sx={{ mr: 2 }}>
          Areas of {functionName}
        </Typography>
        <Chip label={roles.length} size="small" color="primary" />
      </Box>
      <TextField
        placeholder="Search specific job"
        variant="outlined"
        size="small"
        fullWidth
        sx={{ mb: 3, maxWidth: 500 }}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      <Grid container spacing={3}>
        {filteredRoles.map((role) => (
          <Grid item xs={12} sm={6} md={4} key={role.id}>
            <Card
              elevation={selectedRoleIds.includes(role.id) ? 8 : 2}
              sx={{
                borderRadius: 3,
                border: selectedRoleIds.includes(role.id)
                  ? "2px solid #6C5CE7"
                  : "1px solid #e0e0e0",
                boxShadow: selectedRoleIds.includes(role.id)
                  ? "0 0 0 2px #6C5CE733"
                  : undefined,
                transition: "border 0.2s, box-shadow 0.2s",
              }}
            >
              <CardActionArea onClick={() => handleCardClick(role.id)}>
                <CardContent
                  sx={{
                    minHeight: 80,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h5" align="center">
                    {role.name}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          color="primary"
          disabled={selectedRoleIds.length === 0}
          onClick={handleDiscoverCandidates}
        >
          Discover candidates
        </Button>
      </Box>
    </Box>
  );
};

export default FunctionRoles;
